import { readFileAsBase64 } from '@/utils/file-to-base64'
import valid from '@/utils/valid-check'
import { uploadImg } from '@/api'

export const uploadFileHelper = async (selectedFile, options) => {
  // 解构配置选项并设置默认值
  const {
    allowedTypes = [],
    typeTips = '',
    maxSize = 10 * 1024 * 1024, // 默认 10MB
    onSuccess = () => {},
    onError = () => {},
    onLoading = () => {}
  } = options;

  // 基本验证
  if (!selectedFile) {
    onError('请选择一个文件');
    return;
  }

  // 验证文件类型
  const isValidType = allowedTypes.includes(selectedFile.type);
  if (!isValidType) {
    if (valid.notEmptyBool(typeTips)) {
      onError(typeTips)
    }else{
      onError(`文件类型无效，支持的类型：${allowedTypes.join(', ')}`);
    }
    return;
  }

  // 验证文件大小
  if (selectedFile.size > maxSize) {
    onError(`文件大小超出限制（最大 ${maxSize / (1024 * 1024)}MB）`);
    return;
  }
  // 显示加载状态
  onLoading(true);

  try {
    // 读取文件为 Base64
    const fileBase64 = await readFileAsBase64(selectedFile);
    let re = await uploadImg(fileBase64, 44);
    const url = re.replace(/https?:\/\//, 'https://');
    console.log("fileUrl------->",url)
    // 执行成功回调
    onSuccess(url);
  } catch (error) {
    // 执行错误回调
    onError('上传过程中发生错误,请重试',error);
    console.log("uploadError--->",error);

  } finally {
    // 隐藏加载状态
    onLoading(false);
  }
};
